"use client";
import { jsx as e } from "react/jsx-runtime";
import { COMPONENT_SIZES as h } from "../../common/constants/componentSizes.js";
import N from "../link/Link.js";
import { css as t } from "@emotion/react";
import i from "@emotion/styled";
import { COLORS as o } from "../../tokens/colors/Colors.js";
import { MOTION_DURATIONS as S } from "../../tokens/motion-durations/MotionDurations.js";
import { MOTION_EASINGS as v } from "../../tokens/motion-easings/MotionEasings.js";
import { SIZES as s } from "../../tokens/sizes/Sizes.js";
import { SPACINGS as b } from "../../tokens/spacings/Spacings.js";
import { forwardRef as g } from "react";
const m = g(
  ({
    "aria-label": r = "Main navigation",
    feItems: a,
    feVertical: n = !1,
    ...d
  }, f) => /* @__PURE__ */ e(y, { ...d, "aria-label": r, ref: f, children: /* @__PURE__ */ e(O, { feVertical: n, role: "menubar", children: a == null ? void 0 : a.map(({ children: p, icon: l, ...$ }, c) => /* @__PURE__ */ e(u, { feVertical: n, role: "menuitem", children: /* @__PURE__ */ e(
    w,
    {
      ...$,
      as: "a",
      feColor: "secondary",
      feIcon: l && {
        feIcon: l,
        position: "left"
      },
      feVertical: n,
      children: p
    }
  ) }, c)) }) })
);
m.displayName = "HeaderNav";
const _ = m, y = i.nav`
	background-color: ${o.brand};
`, O = i.ul(
  ({ feVertical: r }) => t`
		display: ${!r && "flex"};
	`
), u = i.li(
  ({ feVertical: r }) => t`
		min-width: ${!r && 0};
	`
), w = i(N)(
  ({
    feVertical: r,
    selected: a
  }) => t`
		height: ${h.headerHeight};
		padding-inline: ${b.lg};
		position: relative;

		&::after {
			bottom: 0;
			content: '';
			left: 0;
			position: absolute;
			transition: transform ${S.fast}ms ${v.easeIn};
		}

		${a && t`
			background-color: ${o.white};
			color: ${o.gray700};

			&:hover {
				color: ${o.gray700};
			}
		`}

		${!r && t`
			max-width: 100%;

			&::after {
				border-bottom: ${s.s04} solid ${o.white};
				right: 0;
				transform: translateY(100%);
			}

			&:hover {
				&::after {
					transform: translateY(0);
				}
			}
		`}

		${r && t`
			width: 100%;

			&::after {
				border-left: ${s.s04} solid ${o.white};
				top: 0;
				transform: translateX(-100%);
			}

			&:hover {
				&::after {
					transform: translateX(0);
				}
			}
		`}
	`
);
export {
  _ as default
};
